import { React } from "react";
const Sidebar = ({ items, activeId, sideBarOnClick }) => {
  const buildActiveClass = (id) => {
    return id === activeId
      ? " bg-light-secondary-1 dark:bg-dark-secondary-1 text-light-primary-1 dark:text-dark-primary-2 "
      : "";
  };
  const sidebarItems = [];
  items.forEach((content, id) => {
    const element = (
      <button
        onClick={sideBarOnClick}
        id={id}
        className={
          buildActiveClass(id) +
          "block p-5 text-center text-sm hover:bg-light-secondary-1 hover:text-light-primary-1 dark:hover:border-l-2 dark:hover:border-solid dark:hover:border-dark-primary-3 dark:hover:bg-dark-secondary-1 dark:hover:text-dark-primary-2 dark:active:border-l-2 dark:active:border-solid dark:active:border-dark-primary-3 dark:active:bg-dark-secondary-1 dark:active:text-dark-primary-2  md:text-3xl"
        }
      >
        {content}
      </button>
    );
    sidebarItems.push(element);
  });
  return (
    <div
      id="sidebar"
      className={
        "flex w-1/3 flex-col items-stretch justify-start bg-light-primary-1 text-light-secondary-1 dark:bg-dark-primary-1 dark:text-dark-primary-2 md:w-1/6"
      }
    >
      {sidebarItems}
    </div>
  );
};

export default Sidebar;
